import React, {useCallback} from "react";
import { useUserContext} from "../../contexts/user-context";
import { useSalesTeamQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";
import {GraphQlSelectId} from "./GraphQlSelectId";


export function SalesTeamSelect(props) {
    const query = useSalesTeamQueryQuery();
    const userContext = useUserContext();
    const user = userContext.user;
    // only show sales teams that the user is a member of
    let filterOptions = useCallback((options) => {
        const auth = user.salesTeams.map((k) => k.id);
        return options.filter((option) => {
            const isAuthorized = auth.indexOf(option.id) > -1;
            // Exclude the team specified in hideTeam prop
            const isNotHidden = option.prefix !== props.hideTeam;
            return isAuthorized && isNotHidden;
        });
    }, [user, props.hideTeam]);

    if (!props.needsAuth) {
        filterOptions = null;
    }
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  filterOptions={filterOptions} labelField="name" />:<GraphQlSelect queryResult={query} {...props}  filterOptions={filterOptions} labelField="name" />;
}